import { render, staticRenderFns } from "./ProductionDataPanel.vue?vue&type=template&id=155327e1&scoped=true"
import script from "./ProductionDataPanel.vue?vue&type=script&lang=js"
export * from "./ProductionDataPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductionDataPanel.vue?vue&type=style&index=0&id=155327e1&prod&scoped=true&lang=css"
import style1 from "./ProductionDataPanel.vue?vue&type=style&index=1&id=155327e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155327e1",
  null
  
)

export default component.exports